import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import "./Home.css";
import "../Products/visaRequirement/VisaCheck.css";

import Hero from "./Hero";
import Destinations from "./Destinations";
import CTABanner from "./CTABanner";
import Testimonials from "./Testimonials";
import FAQ from "./FAQ";
import VisaChecker from "./VisaChecker";
// import { ContactUs, ScheduleMeetingFloat } from "./Contact";
import { ContactUs } from "./Contact";
import { matchesCountryString } from "../../../utils/countrySearch";
import { destinations as destinationsFallback, normalizeDestinationCountries } from "./homeData/destinations";
import configService from "../../../services/configService";

export default function Home() {
  const [destinations, setDestinations] = useState([]);
  const [destinationsLoading, setDestinationsLoading] = useState(true);
  const [searchParams] = useSearchParams();
  
  useEffect(() => {
    let mounted = true;
    setDestinationsLoading(true);
    configService.getConfig()
      .then((r) => {
        if (!mounted) return;
        const data = normalizeDestinationCountries(r.data?.destinationCountries, r.data?.visaProducts || []);
        setDestinations(data);
      })
      .catch(() => {
        if (!mounted) return;
        setDestinations(destinationsFallback);
      })
      .finally(() => {
        if (!mounted) return;
        setDestinationsLoading(false);
      });
    return () => { mounted = false; };
  }, []);

  // Read search from URL directly each render - no state needed
  const urlSearch = searchParams.get("q") || searchParams.get("search") || "";
  
  const [search, setSearch] = useState(urlSearch);
  const [region, setRegion] = useState("All");
  const [type, setType] = useState("All");
  const [popularity, setPopularity] = useState("All");

  // Combine local search with URL search for filtering
  const effectiveSearch = urlSearch || search;

  const filteredDestinations = destinations.filter((destination) => {
    const matchSearch = matchesCountryString(destination.name, effectiveSearch);
    const matchRegion = region === "All" || destination.region === region;
    const matchType = type === "All" || destination.tag === type;
    const matchPopularity = popularity === "All" || destination.popularity === popularity;

    return matchSearch && matchRegion && matchType && matchPopularity;
  });

  return (
    <div className="home-app">
      <Hero
        search={search}
        setSearch={setSearch}
        region={region}
        setRegion={setRegion}
        type={type}
        setType={setType}
        popularity={popularity}
        setPopularity={setPopularity}
        filteredCount={filteredDestinations.length}
      />
      <Destinations
        search={search}
        filteredDestinations={filteredDestinations}
        isLoading={destinationsLoading}
      />
      <VisaChecker />
      <CTABanner />
      <Testimonials />
      <FAQ />
      <ContactUs />
      {/* COMMENTED FOR FUTURE USE - ScheduleMeeting button
      <ScheduleMeetingFloat />
      */}
    </div>
  );
}
